import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es6.array.map.js";
import fetch from 'cross-fetch';
import { retry } from './retry';

function attemptTransport(_x, _x2, _x3) {
  return _attemptTransport.apply(this, arguments);
}
/**
 * Default basic method to POST an array of events to our graph through the
 * gateway to publish into the correct Yak exchange.
 *
 * @returns {Promise} - Promise object to resolve or reject with results of publish
 */


function _attemptTransport() {
  _attemptTransport = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(events, headers, options) {
    var _options$exchangeId, exchangeId, _options$operationNam, operationName, _options$field, field, _options$query, query, baseUrl, res, json, data, errors, error;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            // these options are configurable here so that tests can force yak to return an error
            // and that the error handling in this method can be asserted
            _options$exchangeId = options.exchangeId, exchangeId = _options$exchangeId === void 0 ? 'ANALYTIC_PIPELINE_MOUTH' : _options$exchangeId, _options$operationNam = options.operationName, operationName = _options$operationNam === void 0 ? 'PublishAnalyticsEvents' : _options$operationNam, _options$field = options.field, field = _options$field === void 0 ? 'publishYakMessages' : _options$field, _options$query = options.query, query = _options$query === void 0 ? "\n      mutation ".concat(operationName, "($messages: [YakMessageInput!]!) {\n        ").concat(field, "(messages: $messages) {\n          success\n        }\n      }\n    ") : _options$query, baseUrl = options.baseUrl;
            _context.next = 3;
            return fetch(baseUrl, {
              // Use `credentials: include` to allow for cross-origin requests to
              // include cookies. For example, when making a cross-origin request
              // from localnerd.nerdwallet.com to api.nerdwallet.biz, this allows
              // requests to include cookies set for api.nerdwallet.biz. Without
              // `credentials: include`, no cookies would be sent. This allows
              // local development against stage or prod supergraph-gateway.
              credentials: 'include',
              method: 'POST',
              headers: _objectSpread(_objectSpread({}, headers), {}, {
                'Content-Type': 'application/json'
              }),
              body: JSON.stringify({
                operationName: operationName,
                query: query,
                variables: {
                  messages: events.map(function (_ref) {
                    var eventType = _ref.eventType,
                        payload = _ref.payload,
                        id = _ref.id;
                    // Transform an analytics event into a YakMessageInput
                    return {
                      exchangeId: exchangeId,
                      id: id,
                      type: eventType,
                      payload: payload
                    };
                  })
                }
              })
            });

          case 3:
            res = _context.sent;
            _context.next = 6;
            return res.json();

          case 6:
            json = _context.sent;
            data = json.data, errors = json.errors;

            if (!errors) {
              _context.next = 14;
              break;
            }

            if (!(errors[0].extensions.code === 'MULTI_STATUS_ERROR')) {
              _context.next = 11;
              break;
            }

            return _context.abrupt("return", errors[0].extensions.results);

          case 11:
            error = new Error('transportGraphQL error');
            error.data = errors;
            throw error;

          case 14:
            return _context.abrupt("return", data[field]);

          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _attemptTransport.apply(this, arguments);
}

export default function transportGraphQL(_x4, _x5, _x6) {
  return _transportGraphQL.apply(this, arguments);
}

function _transportGraphQL() {
  _transportGraphQL = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(events, headers, options) {
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", retry(function () {
              return attemptTransport(events, headers, options);
            }, {
              maxAttempts: options.maxAttempts,
              maxDelayMs: options.maxDelayMs
            }));

          case 1:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _transportGraphQL.apply(this, arguments);
}